import { render, staticRenderFns } from "./TaxCredit.vue?vue&type=template&id=4b75c352"
import script from "./TaxCredit.vue?vue&type=script&lang=js"
export * from "./TaxCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports